import React, { useState, useEffect } from 'react';
import CartInDecGroupBox from './CartInDecGroupBox';
import { useSelector, useDispatch } from 'react-redux';
import CurrencyCodeAdd from '@/components/common/CurrencyCodeAdd';
import { getFileUrl } from '@/services/CommonService';
import { updateCartItemQuantityTable, removeFromCartTable } from '@/store/actions';
import { Link } from 'react-router-dom';

const POSSidebarTable = () => {
    const { tableOrder } = useSelector((state) => state?.GeneralSetting);
    const dispatch = useDispatch();

    const removeInToCart = (itemId, index) => {
        dispatch(removeFromCartTable({ _id: itemId, index: index }));
    };

    const cartQuantityUpdate = (itemId, itemQuantity, cartIndex) => {
        dispatch(updateCartItemQuantityTable({ _id: itemId, quantity: itemQuantity, index: cartIndex }));
    };

    const cartItemChange = async (name, value, index) => {
        const currentIndex = parseInt(index - 1);
        const cartItemsFind = tableOrder?.cartItems[currentIndex] || '';
        if (cartItemsFind && cartItemsFind?._id) {
            cartQuantityUpdate(cartItemsFind?._id, value, currentIndex);
        }
    };

    return (
        tableOrder?.cartItems &&
        tableOrder?.cartItems.length > 0 &&
        tableOrder?.cartItems.map((cart, index) => (
            <div key={index} className="mb-3 pb-3 border-b last:mb-0 last:pb-0 last:border-b-0 border-gray-2">
                <div className="flex items-center gap-3 mb-2">
                    <img className="w-16 h-16 rounded-lg flex-shrink-0" src={getFileUrl(cart?.file_name, 'product')} alt="thumbnail" />

                    <div className="w-full">
                        <Link to="#" className="text-sm font-medium capitalize transition text-heading hover:underline">
                            {cart.name}
                        </Link>
                        <p className="capitalize text-xs mb-1.5">
                            {cart?.item_variations?._ids &&
                                cart?.item_variations?._ids.length > 0 &&
                                cart?.item_variations?._ids.map((item_variation, ind) => (
                                    <span key={ind}>
                                        <span className="">{cart?.item_variations?.attribute_name[ind]}: </span>
                                        <span className="">{cart?.item_variations?.name[ind]}</span>
                                    </span>
                                ))}
                        </p>
                        <div className="flex items-center justify-between gap-2">
                            <h3 className="text-xs font-semibold">
                                <CurrencyCodeAdd price={cart.total_price} />
                            </h3>
                            <CartInDecGroupBox
                                inputName="item_qty"
                                cartId={cart?._id}
                                indexKey={index + 1}
                                onChangeValue={cartItemChange}
                                inputValue={cart?.quantity}
                                buttonClassName={'w-[18px] h-[18px]'}
                            />
                        </div>
                        <ul className="flex flex-col gap-1.5">
                            <li className="leading-4 flex gap-1">
                                <h3 className="capitalize text-xs w-fit whitespace-nowrap">Extras:</h3>
                                <p className="text-xs">
                                    {cart?.item_extras?._ids &&
                                        cart?.item_extras?._ids.length > 0 &&
                                        cart?.item_extras?._ids.map((item_extra, ind1) => (
                                            <span key={ind1}>
                                                {cart?.item_extras?.name[ind1]}
                                                {ind1 < cart?.item_extras?._ids.length - 1 && ','}
                                            </span>
                                        ))}
                                </p>
                            </li>
                            {cart.instruction && cart.instruction !== '' && (
                                <li className="leading-4 flex gap-1">
                                    <h3 className="capitalize text-xs w-fit whitespace-nowrap">Instruction:</h3>
                                    <p className="text-xs">{cart.instruction}</p>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        ))
    );
};

export default POSSidebarTable;
